// extracted by mini-css-extract-plugin
module.exports = {"buttonWrapper":"buttonWrapper--iFooq","ui":"ui--3v2bX","labeled":"labeled--7ou8L","button":"button--3BUBi","shadowBox":"shadowBox--14rAq"};